// Unblocking a number needs a written reason (at least 10 characters). It goes in the audit log.

import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { formatPhone } from '@bt/core';
import { api, type Contact } from '../api';
import { Dialog } from './Dialog';
import { InlineError } from './States';

export function UnblockDialog({ contact, onClose, onDone }: { contact: Pick<Contact, 'id' | 'name' | 'phone_number'>; onClose: () => void; onDone: () => void }) {
  const [reason, setReason] = useState('');
  const m = useMutation({
    mutationFn: () => api.contacts.optOut(contact.id, 'unblock', reason.trim()),
    onSuccess: () => {
      onDone();
      onClose();
    },
  });
  const ok = reason.trim().length >= 10;
  return (
    <Dialog title={`Unblock ${contact.name || formatPhone(contact.phone_number)}`} onClose={onClose}>
      <p className="muted">Only unblock when the person asked to hear from us again. Write down how they asked.</p>
      <textarea className="input" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="e.g. Called the office 9/2 and asked for reminders again" autoFocus />
      {!ok && reason.length > 0 && <div className="tiny muted">At least 10 characters.</div>}
      <InlineError error={m.error} />
      <div className="actions">
        <button className="btn" onClick={onClose}>
          Cancel
        </button>
        <button className="btn primary" disabled={!ok || m.isPending} onClick={() => m.mutate()}>
          Unblock
        </button>
      </div>
    </Dialog>
  );
}
